module.exports = __webpack_public_path__ + "cadc40874e3693d3e336d31d295cafcd.gif";